import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie';
import { getUserInfo } from '@/api/user'
import { GetCollectList } from '@/api/collect'
import { GetCartList } from "@/api/cart";
Vue.use(Vuex)




const store = new Vuex.Store({
  state: {
    user: null,
    token: '',
    account: '',
    collect: [],
    carNum: 0,
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getUser(state) {
      return state.user;
    },
    getCollect(state) {
      return state.collect;
    },
    getCarNum(state) {
      return state.carNum;
    }

  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      Cookies.set('token', token);
    },
    setUser(state, user) {
      state.user = user;
      Cookies.set('user', JSON.stringify(user));
    },
    setCollect(state, collect) {
      state.collect = collect;
      
      sessionStorage.setItem('collect', JSON.stringify(collect));
    },
    setCarNum(state, collect) {
      state.carNum = collect;
      sessionStorage.setItem('carNum', JSON.stringify(carNum));
    },
  },
  actions: {
    //退出登录
    logout({ commit }) {
      commit('setToken', '');
      commit('setUser', null);
      Cookies.remove('token');
      Cookies.remove('user');
    },
    async GetUserInfo({ commit }) {
      const id = Cookies.get('token');
      const { data } = await getUserInfo(id)
      if (data && data.length > 0) {
        commit('setUser', data[0])
      }
    },
    async getUserCollect({ commit }) {
      const user = JSON.parse(Cookies.get('user'));
      if (!user) return;
      const { data, status } = await GetCollectList(user.id)
      if (status && data.length) {
        commit('setCollect', data)
      }
    },
     getCarNum({ commit }) {
      const user = JSON.parse(Cookies.get('user'));
      if (!user) return;
      GetCartList(user.id).then(res => {
        const arr = res.data || []
        commit('setCarNum', arr.length)
      }).catch(err => {
        
      })
      if (status && data.length) {
        commit('setCollect', data)
      }
    },
  },
  modules: {
  }


})

const token = Cookies.get('token');
const user = Cookies.get('user');
if (token) {
  store.commit('setToken', token);
}
if (user) {
  store.commit('setUser', JSON.parse(user));
}

export default store;